import { useMutation, useQueryClient } from '@tanstack/react-query';
import { knowledgeService } from '../../../services/KnowledgeService';
import type {
  CrawlScheduleInput,
  CrawlScheduleUpdate,
} from '../../../types/knowledge';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';
import { invalidateKnowledgeDatabaseSummaries } from '../knowledgeQueryInvalidation';

export function useCreateKnowledgeCrawlScheduleMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      databaseId,
      input,
    }: {
      databaseId: string;
      input: CrawlScheduleInput;
    }) => knowledgeService.createCrawlSchedule(databaseId, input),
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({
        queryKey: knowledgeQueryKeys.crawlSchedules(variables.databaseId),
      });
      invalidateKnowledgeDatabaseSummaries(queryClient, variables.databaseId);
    },
  });
}

export function useUpdateKnowledgeCrawlScheduleMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      databaseId,
      update,
    }: {
      databaseId: string;
      update: CrawlScheduleUpdate;
    }) => knowledgeService.updateCrawlSchedule(databaseId, update),
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({
        queryKey: knowledgeQueryKeys.crawlSchedules(variables.databaseId),
      });
      invalidateKnowledgeDatabaseSummaries(queryClient, variables.databaseId);
    },
  });
}

export function useDeleteKnowledgeCrawlScheduleMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      databaseId,
      scheduleId,
    }: {
      databaseId: string;
      scheduleId: string;
    }) => knowledgeService.deleteCrawlSchedule(databaseId, scheduleId),
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({
        queryKey: knowledgeQueryKeys.crawlSchedules(variables.databaseId),
      });
      invalidateKnowledgeDatabaseSummaries(queryClient, variables.databaseId);
    },
  });
}
